import React from "react";

// The Black Diamond emblem — a faceted diamond mark rendered in gold.
export default function DiamondMark({ size = 28, className = "", stroke = "#B89C65" }) {
  return (
    <svg
      width={size}
      height={size}
      viewBox="0 0 48 48"
      fill="none"
      className={className}
      aria-hidden="true"
    >
      <path d="M24 3 L44 18 L24 45 L4 18 Z" stroke={stroke} strokeWidth="1.2" fill="none" />
      <path d="M4 18 L44 18" stroke={stroke} strokeWidth="1.2" />
      <path d="M24 3 L15 18 L24 45" stroke={stroke} strokeWidth="0.9" />
      <path d="M24 3 L33 18 L24 45" stroke={stroke} strokeWidth="0.9" />
      <path d="M15 18 L24 3 L33 18" stroke={stroke} strokeWidth="0.9" fill={stroke} fillOpacity="0.12" />
    </svg>
  );
}
